import classNames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./time_to_action.module.scss";

const TimeToActionLegend = () => {
  const { t } = useTranslation("insights");

  return (
    <div className={css.legendWrapper}>
      <div>
        <div className={css.legendItem}>
          <div className={classNames(css.legend, css.first)} />
          {t("timeToShortlist")}
        </div>

        <div className={css.legendItem}>
          <div className={classNames(css.legend, css.second)} />
          {t("timeToAccept")}
        </div>

        <div className={css.legendItem}>
          <div className={classNames(css.legend, css.third)} />
          {t("timeToFill")}
        </div>
      </div>
    </div>
  );
};

export default TimeToActionLegend;
